import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Customer experience & design; LTV & Loyalty; Estratégia e inteligência de Marca",
    correct: false,
  },
  {
    option:
      "b) LTV & Loyalty; Customer experience & design; Martech & Analytics",
    correct: false,
  },
  {
    option:
      "c) Estratégia e inteligência de Marca; Conteúdo & Mídia; Comportamento do consumidor & insights ágeis",
    correct: true,
  },
  {
    option:
      "d) Estratégia e inteligência de Marca; Customer experience & design; Growth & Performance",
    correct: false,
  },
  {
    option:
      "e) Martech & Analytics; Estratégia e inteligência de Marca; Mensuração e otimização de MROI",
    correct: false,
  },
];

export default function Question9(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question9: {
          title:
            "Você está prospectando uma empresa com uma estrutura de marketing baseada em produtos e não canais, quais são as ofertas mais importantes para esse tipo de empresa?",
          option: option.option,
          correct: option.correct,
          order: 9
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Você está prospectando uma empresa com uma estrutura de marketing baseada em produtos e não canais, quais são as ofertas mais importantes para esse tipo de empresa?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
